import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
// import { AngularFireModule } from 'angularfire2';
// import { AngularFirestoreModule } from 'angularfire2/firestore';

import { TableModule } from 'primeng/table';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { EditorModule } from 'primeng/editor';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { GrowlModule } from 'primeng/growl';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';

import { RadioButtonModule } from 'primeng/radiobutton';
import { ChartModule } from 'primeng/chart';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';

import { AppComponent } from './app.component';

import { DataService } from './providers/data.service';
import { PopupComponent } from './components/popup/popup.component';
import { MessageComponent } from './components/message/message.component';
import { LoaderComponent } from './components/loader/loader.component';

import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { PagesComponent } from './pages/pages/pages.component';

import { LoginComponent } from './pages/login/login.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { ProductsComponent } from './pages/products/products.component';
import { UsersComponent } from './pages/users/users.component';

import { MessagesComponent } from './pages/messages/messages.component';

import { TextCenterDirective } from './directives/text-center.directive';
import { PaddingDirective } from './directives/padding.directive';
import { StatsComponent } from './pages/stats/stats.component';
import { TranslationsComponent } from './pages/translations/translations.component';

// export const firebaseConfig = {
//     apiKey: "AIzaSyBYhp_BYo84zOvOchHHLhlX0q1ynwA3RPo",
//     authDomain: "brandnewlive-f53aa.firebaseapp.com",
//     databaseURL: "https://brandnewlive-f53aa.firebaseio.com",
//     projectId: "brandnewlive-f53aa",
//     storageBucket: "brandnewlive-f53aa.appspot.com",
//     messagingSenderId: "393071487242"
// };

export const _NgModules = [
    TableModule,
    EditorModule,
    ButtonModule,
    MenubarModule,
    ProgressSpinnerModule,
    MenuModule,
    PaginatorModule,
    CalendarModule,
    MultiSelectModule,
    GrowlModule,
    RadioButtonModule,
    ChartModule,
    FileUploadModule,
    ConfirmDialogModule,
    DialogModule,
    DropdownModule
];

@NgModule({
  declarations: [
    AppComponent,
    MessagesComponent,
    PopupComponent,
    NavbarComponent,
    FooterComponent,
    LoaderComponent,
    TextCenterDirective,
    HomeComponent,
    PagesComponent,
    OrdersComponent,
    ProductsComponent,
    UsersComponent,
    MessageComponent,
    PaddingDirective,
    LoginComponent,
    StatsComponent,
    TranslationsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule, ReactiveFormsModule,
    // AngularFireModule.initializeApp(firebaseConfig),
    // AngularFirestoreModule,
    _NgModules
  ],
  providers: [DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/app.module.ts